module.exports = __webpack_public_path__ + "static/media/available-play-store.2523bc69.png";